import React from 'react';
import PropertyFor from './PropertyFor';

const ForcePropertyFor = ({ $c, ...props }) => (
  <PropertyFor property={{ $c }} {...props} />
);

export default ForcePropertyFor;
